<app-bulk-number-input
  [label]="label"
  [digitLimit]="4"
  [placeholder]="'Paste or enter a list of store numbers and press enter'"
  [errorMessage]="errorMessage"
  [allowedNumbers]="allowedStoreNumbers"
  (validatedBulkInput)="onValidatedBulkInput($event)"     
  >
</app-bulk-number-input>
